export default {
  TITLE: `My Settings`,
  SUMMARY: ``,
  COLOR_NORMAL: `Standard`,
  COLOR_HIGH_CONTRAST: `High-contrast`,
  COLOR_ICONS: `Standard + Icons`,
  SCHEDULER_OPTIONS: `Scheduler options:`,
  SCHEDULER_COLORS: `Scheduler colors:`,
  OTHER_OPTIONS: `Other options:`,
  SHOW: `Restore all dismissed help cards`,
  HELP_CARD_DISMISS_MSG: `You have dismissed at least one help card in Merinio, do you want to restore them?`,
  HELP_CARD_ALL_SHOWED_MSG: `All the available help cards are currently visible.`,
  SCHEDULEEDGESCROLLING: {
    LABEL: `Edge scrolling`,
    PLACEHOLDER: ``,
    DESCRIPTION: `If enabled, you can scroll the scheduler view by moving the mouse pointer to the edges of the scheduler window.`
  },
  GROUPSCHEDULEEVENTS: {
    LABEL: `Grouping of schedule events`,
    PLACEHOLDER: ``,
    DESCRIPTION: `Allows overlapping events within the same position to be collapsed.`
  },
  SCHEDULEREVENTSHIGHCONTRAST: {
    LABEL: `High contrast mode`,
    PLACEHOLDER: ``,
    DESCRIPTION: `Changes colors of shifts in schedule to increase differences between colors and contrast.`
  },
  ENABLEDATEPICKERMANUALINPUT: {
    LABEL: `Date picker manual input`,
    PLACEHOLDER: ``,
    DESCRIPTION: `Enable manual input on all date and time pickers, this also increases the number of clicks required to change the date or time.`
  },
  CSVDELIMITER: {
    LABEL: `CSV delimiter`,
    PLACEHOLDER: ``,
    DESCRIPTION: `The character to use when separating data in csv files (English Excel uses ',').`
  }
}
